/**
 * Constants declaring zIndex layers.
 */
export var zIndex;

(function (zIndex) {
  zIndex[zIndex["Default"] = 0] = "Default";
  zIndex[zIndex["StickyTableHeader"] = 10] = "StickyTableHeader";
  zIndex[zIndex["StickyTableColumn"] = 200] = "StickyTableColumn";
  zIndex[zIndex["StickyTableCorner"] = 300] = "StickyTableCorner";
  zIndex[zIndex["AppHeader"] = 400] = "AppHeader";
  zIndex[zIndex["ModalBackdrop"] = 500] = "ModalBackdrop";
  zIndex[zIndex["ModalWindow"] = 600] = "ModalWindow";
  zIndex[zIndex["SuperModalWindow"] = 700] = "SuperModalWindow";
  zIndex[zIndex["DropDown"] = 800] = "DropDown";
})(zIndex || (zIndex = {}));